import { type QueryClient } from 'react-query'

export const invalidateQueriesList = (
  queryClient: QueryClient,
  keys: Array<string | [string] | [string, number]>
) => {
  return Promise.all(
    keys.map((key) => {
      return queryClient.invalidateQueries(key)
    })
  )
}
